import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck, Coins, HeadphonesIcon, ShieldCheck } from "lucide-react";

const HERO = "https://customer-assets.emergentagent.com/job_jungle-retreat-3/artifacts/xlxaxtfd_Forest%20Retreat.png";

export default function BecomeAHost() {
  return (
    <div className="bg-ivory">
      <section className="relative min-h-[80vh] flex items-end overflow-hidden">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover animate-subtle-pan" />
        <div className="absolute inset-0 bg-gradient-to-t from-forest-900/95 via-forest-900/60 to-forest-900/20" />
        <div className="relative container-tarzan py-24 text-ivory">
          <div className="eyebrow text-sand-200 mb-4">Host with Tarzan</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[1.02] tracking-tight max-w-3xl">Your home, in our most loved collection.</h1>
          <p className="mt-6 text-ivory/80 max-w-xl text-base md:text-lg leading-relaxed">If you own a thoughtfully built home in the lap of nature, we'd love to talk. We manage everything — guests, marketing, housekeeping, care.</p>
          <div className="flex flex-wrap gap-3 mt-8">
            <Link to="/contact" className="bg-ivory text-forest px-7 py-3.5 rounded-full text-sm font-medium hover:bg-sand-100 transition-colors inline-flex items-center gap-2">List your property <ArrowRight className="h-4 w-4" /></Link>
            <Link to="/contact" className="border border-ivory/40 text-ivory px-7 py-3.5 rounded-full text-sm font-medium hover:bg-ivory hover:text-forest transition-colors">Talk to our team</Link>
          </div>
        </div>
      </section>

      <section className="py-24">
        <div className="container-tarzan grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-7">
          {[
            { i: Coins,           h: "Higher yields",     b: "Premium pricing, premium guests. Average partner sees 2.3× pre-Tarzan revenue." },
            { i: BadgeCheck,      h: "Curated audience",  b: "Travelers who respect the home. We screen every booking and brief every guest." },
            { i: HeadphonesIcon,  h: "End-to-end care",   b: "Listings, marketing, housekeeping, concierge — handled by our team, branded to your home." },
            { i: ShieldCheck,     h: "Damage protection", b: "Every stay is covered. We make it right, fast, and without drama." },
          ].map(({i:Ic,h,b}) => (
            <div key={h} className="bg-white border border-forest/10 rounded-3xl p-7 soft-shadow">
              <div className="h-12 w-12 rounded-full bg-forest text-ivory grid place-items-center mb-5"><Ic className="h-5 w-5" strokeWidth={1.5} /></div>
              <div className="font-serif text-xl text-ink">{h}</div>
              <p className="text-ink-soft text-sm mt-3 leading-relaxed">{b}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 bg-forest-50/60">
        <div className="container-tarzan max-w-3xl">
          <div className="eyebrow mb-3">How it works</div>
          <h2 className="font-serif text-4xl md:text-5xl text-ink tracking-tight">From first call to first guest in <em className="not-italic text-forest">~30 days.</em></h2>
          <ol className="mt-10 space-y-7">
            {[
              ["Conversation", "We talk about your home, location, vision, and existing operations."],
              ["Site visit",   "A member of our team visits and stays a night. We share honest feedback."],
              ["Onboarding",   "We photograph the home, write the listing, set pricing, and brief the staff."],
              ["Going live",   "Your home launches across Tarzan's channels. First bookings typically arrive within 14 days."],
            ].map(([h, b], i) => (
              <li key={h} className="flex gap-6 items-start">
                <div className="h-12 w-12 shrink-0 rounded-full border border-forest/30 grid place-items-center font-serif text-xl text-forest">0{i+1}</div>
                <div>
                  <div className="font-serif text-2xl text-ink">{h}</div>
                  <div className="text-ink-soft mt-1 leading-relaxed">{b}</div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </div>
  );
}
